
export function checkNull(obj) {
  if (obj === undefined || obj === null) return true;
  if (Array.isArray(obj)) {
    return obj.length <= 0;
  }
  // delete  obj['__ob__']
  try {
    return !!(obj === "" || JSON.stringify(obj) === JSON.stringify({}));
  } catch (e) {
    return false;
  }
  ;
}

export const validatePhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error($vm.$i18n.t('common.required')))
  } else {
    callback()
  }
  // if(value.toString().substr(0,1)!= '0'){
  //   value = '8550'+ value
  // }else{
  //   value='855'+value
  // }
  // const reg = /^855(0)?(10|15|16|69|70|81|86|87|93|98|96|88|97|71|60|66|67|68|90|31|91|11|12|14|17|61|76|77|78|85|89|92|95|99|18|38|13|80|83|84|79)[0-9]{6,7}$/
  // const formattedValue = String(value).trim()
  // // 去掉区号后检验是否为空字符串
  // const trimAreaCodeValue = formattedValue.replace(/^855(0)?/, '')
  // if (trimAreaCodeValue && !reg.test(formattedValue)) {
  //   callback(new Error($vm.$i18n.t('common.invalid_phone')))
  // } else {
  //   callback()
  // }
}

// 校验选择的值是否为空
export const validRequired = (rule, value, callback, source, options) => {
  if ((!value && value !== 0) || !(value.toString().trim().length > 0)) {
    callback(new Error($vm.$i18n.t('common.required')))
  } else {
    callback(undefined)
  }
}

// 校验数值范围
export const validNumberRange = (min, max) =>
  (rule, value, callback, source, options) => {
    if (!(min <= value - 0 && max >= value - 0)) {
      callback(
        new Error($vm.$i18n.t("common.enter_num_between", { arg0: min - 0, arg1: max - 0 }))
      );
    } else {
      callback(undefined);
    }
  };

// 是否是数字

export const isNumber = data => /^-?[0-9]+\.?[0-9]{0,}$/.test(String(data));

// 校验选择的集合是否为空
export const validListRequired = (rule, value, callback, source, options) => {
  if (!value || !value.length) {
    callback(new Error($vm.$i18n.t('common.selection_required')))
  } else {
    callback()
  }
}

//  详情长度校验 - 100
export const validateDescription = (rule, value, callback) => callback(value && value.toString().length > 100 && new Error('Maximum length exceeded') || undefined);

//  名称长度校验 - 50
export const validateName = (rule, value, callback) => callback(value && value.toString().length > 50 && new Error('Maximum length exceeded') || undefined);

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

export const numberReg = /^-?[0-9]+\.?[0-9]*$/;

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

e
export function validateNull(val){
  if (val instanceof Date || typeof val === 'boolean' || typeof val === 'number') return false;
  if (val instanceof Array) {
    if (val.length === 0) return true;
  } else if (val instanceof Object) {
    for (var o in val) {
      return false;
    }
    return true;
  } else {
    if (
      val === 'null' ||
      val == null ||
      val === 'undefined' ||
      val === undefined ||
      val === ''
    ) {
      return true;
    }
    return false;
  }
  return false;
}


// 仅支持数字、英文大小写字母输入
export const validateNumberLetter = (rule, value, callback) => {
	const reg = /^[A-Za-z0-9]+$/
	const formattedValue = value && String(value).trim()
	if (formattedValue && !reg.test(formattedValue)) {
		callback(new Error($vm.$i18n.t('只能输入英文数字组合')))
	} else {
		callback()
	}
}